import React from 'react';
import { useNavigate } from 'react-router-dom';
import Toolbar from '../Toolbar';
import { usePermission } from '../../hooks/usePermission';
import './Layout.css';

interface HeaderProps {
  onMenuToggle: () => void;
}

const Header: React.FC<HeaderProps> = ({ onMenuToggle }) => {
  // ENH-001 — 타이틀 클릭 시 역할별 홈으로 이동.
  const navigate = useNavigate();
  const { isUser } = usePermission();
  const goHome = () => navigate(isUser ? '/my-events' : '/');

  return (
    <header className="header">
      <button className="header__menu-btn" onClick={onMenuToggle}>
        ☰
      </button>
      <div
        className="header__title header__title--clickable"
        onClick={goHome}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') goHome(); }}
      >
        차량 과속 모니터링
      </div>
      <Toolbar />
    </header>
  );
};

export default Header;
